import type { IAddressInfoDto, IIdVerificationInfoModel } from './Types';

function fromAddressInfoDto(addressInfoDto: IAddressInfoDto | null) {
  const { homeAddress = '', city = '', state = '', zipCode = '' } = addressInfoDto ?? {};

  return {
    address: homeAddress ? String(homeAddress) : '',
    city: city ? String(city) : '',
    state: state ? String(state) : '',
    zip: zipCode ? String(zipCode) : '',
  };
}

export default (idVerificationInfo: IIdVerificationInfoModel) => {
  const { firstName, lastName, addressInfoDto } = idVerificationInfo;

  return {
    firstName: firstName && String(firstName),
    lastName: lastName && String(lastName),
    ...fromAddressInfoDto(addressInfoDto),
  };
};
